import { Link } from "react-router-dom";
import { services } from "@/mocks/homeData";

export default function ServicesSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20 lg:py-24">
      <div className="px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-accent-500 border border-accent-200 rounded-full px-3 py-1 mb-3">
              What We Do
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Comprehensive{" "}
              <span className="text-primary-500">Fire Safety</span>{" "}
              Services
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base max-w-md leading-relaxed">
            From risk assessment to system installation, we provide end-to-end fire safety solutions for every property type in Singapore.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {services.map((service) => (
            <Link
              key={service.id}
              to={`/services`}
              className="group relative rounded-2xl overflow-hidden bg-background-50 h-80 md:h-96 block"
            >
              {/* Image */}
              <img
                src={service.image}
                alt={service.title}
                title={`${service.title} - Ezzogenics`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                width="600"
                height="400"
                loading="lazy"
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center mb-3">
                  <i className={`${service.icon} text-background-50 text-lg`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-1">
                  {service.title}
                </h3>
                <p className="text-background-300/90 text-sm leading-relaxed line-clamp-2">
                  {service.description}
                </p>
              </div>

              {/* Hover arrow */}
              <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-background-50/20 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-up-line text-background-50 text-lg"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}